import { Component, Input, OnInit } from '@angular/core'
import { DialogService, isSomething, SaveForm, untilDestroy, ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import {
  AutopilotAutomationBaseComponent,
  AutopilotAutomationConfigurableData,
} from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automation.component'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import {
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'
import { FormBuilder, FormGroup } from '@angular/forms'
import { AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { filter } from 'rxjs/operators'
import { AutomationDocumentFormDialogService } from '@tv3/containers/automations/automations-wizard/short-automations/new-document/dialog/automation-document-form-dialog.service'

@Component({
  selector: 'app-new-document-automation',
  templateUrl: './new-document-automation.component.html',
  styleUrls: ['./new-document-automation.component.scss'],
})
export class NewDocumentAutomationComponent extends AutopilotAutomationBaseComponent implements OnInit {
  @Input() type = AutomationTypes.Document
  @Input() handler = AutomationHandler.SendDocument

  // hide it from inputs
  filterByCategories = false

  form = this.fb.group({
    status: [false],
  })

  constructor(
    private fb: FormBuilder,
    private actions: Actions,
    private automationDocumentFormDialog: AutomationDocumentFormDialogService,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected confirm: ConfirmDialogService
  ) {
    super(store, amplitudeService, confirm)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$.pipe(untilDestroy(this)).subscribe((item) => {
      this.form.patchValue(
        {
          status: !!item?.status,
        },
        { emitEvent: false }
      )
    })

    this.actions
      .pipe(
        ofType(AutomationWizardSaveAction),
        filter(() => this.viewType !== 'table'),
        untilDestroy(this)
      )
      .subscribe((action) => {
        if (this.automationGroup) {
          this.doSave(this.form, { closeAfterSave: action.closeAfterSave })
        } else if (action.closeAfterSave) {
          this.store.dispatch(AutomationWizardCloseAction())
        }
      })
  }

  tryToCreateOrUpdateAutomation(status: boolean) {
    if (this.automationGroup) {
      this.toggleAutomation(status)
    } else {
      this.configureDocumentData()
    }
  }

  onEditDocument() {
    this.configureDocumentData()
  }

  @SaveForm()
  doSave(
    form: FormGroup,
    options?: {
      closeAfterSave?: boolean
      additionalAutomationData?: Partial<AutopilotAutomationConfigurableData>
    }
  ) {
    this.saveAutomation({ ...this.form.getRawValue(), ...options?.additionalAutomationData })
    if (options?.closeAfterSave) {
      this.store.dispatch(AutomationWizardCloseAction())
    }
  }

  getAutopilotId() {
    return `autopilot-document|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }

  configureDocumentData() {
    this.automationDocumentFormDialog
      .open(this.automationGroup)
      .afterClosed()
      .subscribe((data) => {
        if (data) {
          this.doSave(this.form, { additionalAutomationData: data })
        } else if (!this.automationGroup) {
          // reset the toggle
          this.form.patchValue({ status: false }, { emitEvent: false })
        }
      })
  }
}
